﻿import './sections.css'
const BADGES = [
  { icon: '🔐', title: 'Role-Based Access Control', desc: 'Granular permissions ensuring every user sees only what they need to.' },
  { icon: '📋', title: 'Audit Logging', desc: 'Complete activity records for every user action across the platform.' },
  { icon: '☁️', title: 'Secure Cloud Infrastructure', desc: 'Built on enterprise-grade cloud with 99.9% uptime SLA.' },
  { icon: '✅', title: 'Compliance-Ready Architecture', desc: "Designed to meet the standards of the world's most regulated industries." },
]
export default function SecuritySection() {
  return (
    <section className="security-section section">
      <div className="container">
        <p className="section-eyebrow">ENTERPRISE SECURITY</p>
        <h2 className="section-title">Enterprise Security</h2>
        <p className="section-subtitle">PossoBuild is built for enterprise environments. Organizations can confidently deploy the platform across their workforce.</p>
        <div className="security-grid">
          {BADGES.map(b => (
            <div key={b.title} className="security-badge">
              <div className="badge-icon">{b.icon}</div>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}